import { client } from '@/client';

export type LogExportResponse = {
  id: number;
} & (
  | {
      status: 'COMPLETED';
    }
  | {
      status: 'FAILED';
      error: string;
    }
  | {
      status: 'IN_PROGRESS';
      estimatedTimeLeft: number;
    }
);

export async function startTeleIdLogExcelExport(
  signal?: AbortSignal,
): Promise<LogExportResponse> {
  return client
    .post<LogExportResponse>('/teleid/excel-export', null, { signal })
    .then((response) => response.data);
}

export async function getTeleIdLogExcelExport(
  id: number,
  signal?: AbortSignal,
): Promise<LogExportResponse> {
  return client
    .get<LogExportResponse>(`/teleid/excel-export/${id}`, { signal })
    .then((response) => response.data);
}

export async function getTeleIdLogExcelExportResult(
  id: number,
  signal?: AbortSignal,
): Promise<Blob> {
  return client
    .get<Blob>(`/teleid/excel-export/${id}/result`, {
      responseType: 'blob',
      signal,
    })
    .then((response) => response.data);
}

export async function deleteTeleIdLog(signal?: AbortSignal): Promise<void> {
  return client.delete('/teleid', { signal }).then((response) => response.data);
}

export async function startTeleSignLogExcelExport(
  signal?: AbortSignal,
): Promise<LogExportResponse> {
  return client
    .post<LogExportResponse>('/telesign/excel-export', null, { signal })
    .then((response) => response.data);
}

export async function getTeleSignLogExcelExport(
  id: number,
  signal?: AbortSignal,
): Promise<LogExportResponse> {
  return client
    .get<LogExportResponse>(`/telesign/excel-export/${id}`, { signal })
    .then((response) => response.data);
}

export async function getTeleSignLogExcelExportResult(
  id: number,
  signal?: AbortSignal,
): Promise<Blob> {
  return client
    .get<Blob>(`/telesign/excel-export/${id}/result`, {
      responseType: 'blob',
      signal,
    })
    .then((response) => response.data);
}

export async function startTeleSignPdfExport(
  signal?: AbortSignal,
): Promise<LogExportResponse> {
  return client
    .post<LogExportResponse>('/telesign/pdf-export', null, { signal })
    .then((response) => response.data);
}

export async function getTeleSignPdfExport(
  id: number,
  signal?: AbortSignal,
): Promise<LogExportResponse> {
  return client
    .get<LogExportResponse>(`/telesign/pdf-export/${id}`, { signal })
    .then((response) => response.data);
}

export async function getTeleSignPdfExportResult(
  id: number,
  signal?: AbortSignal,
): Promise<Blob> {
  return client
    .get<Blob>(`/telesign/pdf-export/${id}/result`, {
      responseType: 'blob',
      signal,
    })
    .then((response) => response.data);
}

export async function deleteTeleSignLog(signal?: AbortSignal): Promise<void> {
  return client
    .delete('/telesign', { signal })
    .then((response) => response.data);
}
